<template>  
  <v-app-bar height="50" app clipped-left color="white" style="z-index: 9" class="resman-top-nav">
    <v-toolbar-title id="resman-title">ResMan</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-tabs class="resman-tabs" active-class="resman-active-tab" left>
      <v-tabs-slider color="resBlue darken-1"></v-tabs-slider>
      <v-tab class="resman-tab" :to="{ name: 'Landing' }">Budgets</v-tab>
      <v-tab class="resman-tab" :to="{ name: 'GLAccountTemplatesLanding' }">Templates</v-tab>
      <v-tab class="resman-tab" :to="{ name: 'BulkBudgetCreation' }">Global</v-tab>
    </v-tabs>
    <v-spacer></v-spacer>
    <v-toolbar-items id="top-nav-toolbar">
      <top-nav-account-menu></top-nav-account-menu>
    </v-toolbar-items>
  </v-app-bar>  
</template>

<script>
  import TopNavAccountMenu from './menus/TopNavAccountMenu';

  export default {
    name: 'TopNav',
    components: {
      TopNavAccountMenu
    },
    data () {
      return {
      }
    }
  }
</script>

<style lang="scss" scoped>
  .resman-top-nav::v-deep .v-toolbar__content {
    padding-left: 0px;
  }
  #resman-title {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 auto;
    font-family: Roboto;
    font-size: 27.6px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
    background-color: var(--v-resBlue-base) !important;
    /*margin-left: 5px;*/
    height: 50px;
    min-width: 200px;
  }
  .resman-tab {
    background-color: white;
    color: var(--v-resGrey-darken1) !important;
    font-weight: normal !important;
    font-size: 18px !important;
  }

    .resman-tab.resman-active-tab {
      font-weight: 500 !important;
      color: var(--v-resBlue-darken1) !important;
    }


</style>
